const robot = {
  state: {
    detailBreadcrumbList: [],
    addHangUpMessageBreadcrumbList: [],
    robot: {
      robot_id: '',
      robot_name: '',
      type: 0
    },
    robotIntentions: [],
    robotPlatforms: [],
    hangUpMessageData: {}
  },
  mutations: {
    SET_CURRENT_ROBOT: (state, payload) => {
      state.robot = payload
    },
    SET_DETAIL_BREADCRUMB_LIST: (state, payload) => {
      state.detailBreadcrumbList = payload
    },
    SET_HANG_UP_MESSAGE_BREADCRUMB_LIST: (state, payload) => {
      state.addHangUpMessageBreadcrumbList = payload
    },
    SET_ROBOT_INTENTIONS: (state, payload) => {
      state.robotIntentions = payload
    },
    SET_ROBOT_PLATFORMS: (state, payload) => {
      state.robotPlatforms = payload
    },
    SET_HANG_UP_MESSAGE_DATA(state, payload) {
      state.hangUpMessageData = payload
    }
  }
}

export default robot



// WEBPACK FOOTER //
// ./src/store/modules/robot.js